module.exports = __webpack_public_path__ + "static/undo-button-38b997816a43651c3ea4faca89fd6308.png";